<template>
    <div class="popup_box" :style="popup_style">
        <slot>
            <!-- 弹窗内容插槽 -->
        </slot>
    </div>
</template>
<script>
export default {
    props:['popup_style'],
}
</script>
<style lang="scss" scoped>
    @import './index.scss'
</style>